<template>
  <v-dialog width="500" v-model="showForm">
    <v-btn v-if="model" class="ma-0" slot="activator" small>
      <v-icon v-if="model.laboral" color="primary">mdi-check</v-icon>
      <v-icon v-else color="grey">mdi-close</v-icon>
      <v-icon v-if="model.billing" color="primary">mdi-check</v-icon>
      <v-icon v-else color="grey">mdi-close</v-icon>
      <v-icon
        v-if="model.verifactu && verifactuModel && verifactuModel.synced_with_verifactu"
        color="primary"
      >
        mdi-invoice-text-check
      </v-icon>
      <v-icon v-else color="grey">mdi-invoice-text-remove</v-icon>
    </v-btn>

    <v-card class="pa-4">
      <v-card-title class="headline pb-2">Módulos activos</v-card-title>

      <v-divider class="my-2" />

      <v-checkbox v-model="model.laboral" label="Laboral"></v-checkbox>
      <v-checkbox v-model="model.billing" label="Facturación"></v-checkbox>
      <v-checkbox v-model="model.verifactu" label="Verifactu"></v-checkbox>

      <v-divider class="my-4" />

      <h3 class="subtitle-1 font-weight-medium mb-2">Verifactu</h3>
      <p
        v-if="
          verifactuModel &&
            (!initialModel.verifactu ||
              !verifactuModel.name ||
              !verifactuModel.cif ||
              !verifactuModel.synced_with_verifactu)
        "
        class="mb-4"
      >
        Para que Verifactu funcione correctamente, es necesario activar el módulo de facturación, el
        módulo "Verifactu" y crear y sincronizar el perfil de facturación del cliente con Verifactu.
      </p>
      <div v-if="verifactuModel">
        <h4>Perfil de facturación</h4>
        <div class="mb-1">
          {{ verifactuModel.name }}
        </div>
        <div class="mb-2">
          CIF:
          {{ verifactuModel.cif }}
        </div>
      </div>
      <div v-else class="mb-4">
        No existe perfil de Verifactu asociado a este cliente. Crea un perfil de facturación con CIF
        y nombre válidos para la AEAT y podrás activar Verifactu.
      </div>

      <div class="d-flex align-center justify-space-between">
        <div>
          <v-icon
            class="mr-2"
            :color="
              model.verifactu && verifactuModel && verifactuModel.synced_with_verifactu
                ? 'primary'
                : 'grey'
            "
          >
            {{
              verifactuModel && verifactuModel.synced_with_verifactu
                ? 'mdi-invoice-text-check'
                : 'mdi-invoice-text-remove'
            }}
          </v-icon>
          <span class="subtitle-2">
            {{
              model.verifactu && verifactuModel && verifactuModel.synced_with_verifactu
                ? 'Verifactu Activado'
                : 'Verifactu no activado'
            }}
          </span>
        </div>
        <v-btn
          @click="syncVerifactuProfile"
          :disabled="syncing || !verifactuModel || !verifactuModel.cif || !verifactuModel.name"
          small
          outlined
          color="secondary"
        >
          <v-progress-circular v-if="syncing" color="primary" indeterminate :size="20" />
          <template v-else>
            {{
              verifactuModel && verifactuModel.synced_with_verifactu ? 'Resincronizar' : 'Validar'
            }}
          </template>
        </v-btn>
      </div>

      <v-divider class="my-4" />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm()" outlined>
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn color="primary" @click="saveForm()" class="ml-2">
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  name: 'CustomerModulesButton',
  components: {},
  props: {
    clavedat: {
      type: Number,
    },
    value: {
      type: Object,
      default() {
        return {
          laboral: false,
          billing: false,
        };
      },
    },
    verifactuModel: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      showForm: false,
      syncing: false,
      initialModel: null,
    };
  },
  mounted() {
    this.initialModel = { ...this.model };
  },
  computed: {
    model: {
      set: function(value) {
        this.$emit('input', value);
      },
      get: function() {
        if (!this.value) {
          return {
            laboral: false,
            billing: false,
            verifactu: false,
          };
        }
        return this.value;
      },
    },
  },
  methods: {
    syncVerifactuProfile() {
      this.syncing = true;
      if (
        !this.verifactuModel ||
        !this.verifactuModel.cif ||
        !this.verifactuModel.name ||
        !this.verifactuModel.id
      ) {
        this.syncing = false;
        return;
      }

      apiCtrl
        .post(`/openbilling/${this.clavedat}/settings/verifactu/${this.verifactuModel.id}/sync`)
        .then(() => {
          this.$emit('synced-verifactu');
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.syncing = false;
        });
    },
    closeForm() {
      this.showForm = false;
    },
    async saveForm() {
      const data = {
        laboral: this.model.laboral,
        billing: this.model.billing,
        verifactu: this.model.verifactu,
      };

      try {
        await apiCtrl.post(`/customer-modules/${this.clavedat}`, data);
        this.$emit('form-saved');
        this.closeForm();
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    showForm(newVal) {
      if (!newVal) {
        this.model = { ...this.initialModel };
      }
    },
  },
};
</script>

<style></style>
